import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { PulseLoader } from 'react-spinners';

const ConfirmAppointmentPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const confirmAction = async () => {
      if (!token) {
        setMessage('Token no válido.');
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/api/Appointment/confirmar-accion',
          { token }
        );
        setSuccess(true);
        setMessage(response.data || '¡Acción confirmada!');
      } catch (error: any) {
        setSuccess(false);
        setMessage(
          error.response?.data || 'Hubo un error al confirmar o cancelar la cita.'
        );
      } finally {
        setLoading(false);
      }
    };

    confirmAction();
  }, [token]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div
        style={{
          padding: '2rem 3rem',
          borderRadius: '12px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '100%',
          backgroundColor: '#fff',
          fontFamily: 'Arial, sans-serif'
        }}
      >
        <h2 style={{ color: '#4A90E2' }}>Estado de la cita</h2>
        {loading ? (
          <>
            <p>Procesando solicitud...</p>
            <PulseLoader color="#4A90E2" loading={loading} size={12} />
          </>
        ) : (
          <p
            style={{
              color: success ? '#059669' : '#DC2626',
              fontWeight: 'bold',
              backgroundColor: success ? '#D1FAE5' : '#FEE2E2',
              padding: '1rem',
              borderRadius: '8px',
              marginTop: '1rem'
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ConfirmAppointmentPage;